import { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import { MAPBOX_APIKEY } from '@constants';
import { useAuth } from '@context';

export function Mapbox({
  warehouse,
  interactive = true,
}: {
  warehouse: any | null;
  interactive?: boolean;
}) {
  const mapContainerRef = useRef<HTMLDivElement | null>(null);
  const mapRef = useRef<mapboxgl.Map | null>(null);
  const { user } = useAuth();

  useEffect(() => {
    if (!warehouse) return;
    if (!mapContainerRef.current) return;
    mapboxgl.accessToken = MAPBOX_APIKEY;

    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [warehouse.location.lon, warehouse.location.lat],
      zoom: 12,
      interactive,
    });

    if (!user) {
      mapRef.current.on('load', () => {
        mapRef.current?.addSource('circle-source', {
          type: 'geojson',
          data: {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [warehouse.location.lon, warehouse.location.lat],
            },
            properties: {},
          },
        });

        // Add a circle layer
        mapRef.current?.addLayer({
          id: 'circle-layer',
          type: 'circle',
          source: 'circle-source',
          paint: {
            'circle-radius': 100, // Circle radius in pixels
            'circle-color': '#0066cb', // Circle color
            'circle-opacity': 0.5, // Circle opacity
          },
        });
      });
    } else {
      // Add a marker
      new mapboxgl.Marker({ color: 'red' })
        .setLngLat([warehouse.location.lon, warehouse.location.lat])
        .addTo(mapRef.current);
    }
  }, [mapContainerRef.current]);

  return (
    <div
      className='map-container h-[260px] w-full rounded-lg'
      ref={mapContainerRef}
    />
  );
}
